import { progressApi } from "utilities/Axios";
import { AlertHistoryProps } from "../types/alarmtypes";
import { alarmsAPI } from "./types/apiTypes";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const updateAlarm = (tagId: number, status: number) => {
  return progressApi.get(`/AlertTag/SetAlertStatus${extractedPath}?tagId=${tagId}&status=${status}`);
};

export const getAlarms = (): Promise<alarmsAPI> => {
  return progressApi.get(`/AlertTag/GetAlertTagHistories${extractedPath}`);
};

export const updateAlarmHistory = (alarmId: number, status: number) => {
  return progressApi.get(
    `/AlertTag/SetAlertHistoryStatus${extractedPath}?tagHistoryId=${alarmId}&status=${status}`
  );
};

export const deleteAlarm = (alarmId: number) => {
  return progressApi.get(`/AlertTag/DeleteAlertHistory${extractedPath}?tagHistoryId=${alarmId}`);
};

export const getCount = (): Promise<number> => {
  return progressApi.get(`/AlertTag/GetActiveAlertCount${extractedPath}`);
};

export const deleteAllAlarm = () => {
  return progressApi.get(`/AlertTag/DeleteAllAlerts${extractedPath}`);
};

export const acceptAllAlarm = () => {
  return progressApi.get(`/AlertTag/AcceptAllAlerts${extractedPath}`);
};

